module.exports = __webpack_public_path__ + "static/introduction_img2@2x-4b8bf87c5720159798d8f40883b53b7c.jpg";